import * as React from 'react';

import { IKeyValuePairModel, ILookupModel } from '../../../interfaces/ILookup';
import {
    NoteAuditFieldsList,
    decisionUpdate,
    noteContentUpdate,
} from '../../../utilities/Constants';

import Common from '../../../stores/Common';
import { IAuditLogModel } from '../../../interfaces/IAudit';
import { Modal } from 'react-bootstrap';

interface IAuditLogDisplayModel extends IAuditLogModel {
    displayName?: string;
}

export interface INoteEditorHistoryModalProps {
    actionTargetHistory: IKeyValuePairModel[];
    decisionHistory: IAuditLogModel[] | undefined;
    open: boolean;
    onClose: () => void;
}

export function NoteEditorHistoryModal(props: INoteEditorHistoryModalProps) {
    if (!props.open) return null;

    const contentFieldNames = new Set(
        NoteAuditFieldsList.filter((f) => f.type === noteContentUpdate).map((f) => f.name)
    );

    const decisionFieldNames = new Set(
        NoteAuditFieldsList.filter((f) => f.type === decisionUpdate).map((f) => f.name)
    );

    const displayNameByField = new Map(NoteAuditFieldsList.map((f) => [f.name, f.displayName]));

    const mapHistory = (
        history: IAuditLogDisplayModel[] | undefined,
        fieldNames: Set<string | undefined>
    ): IAuditLogDisplayModel[] =>
        history
            ?.filter((h) => fieldNames.has(h.fieldName))
            .map((h) => ({
                ...h,
                displayName: displayNameByField.get(h.fieldName),
            })) ?? [];

    const editHistory = mapHistory(props?.decisionHistory, contentFieldNames);
    const decisionHistory = mapHistory(props?.decisionHistory, decisionFieldNames);

    return (
        <Modal
            centered
            show={props.open}
            onHide={props.onClose}
            backdropClassName="transparent-background"
        >
            <Modal.Header>
                <Modal.Title>History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="pb-3">
                    <h5 className="pb-2" style={{ fontWeight: 500 }}>
                        Edit History
                    </h5>
                    {(editHistory?.length ?? 0) > 0 && (
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Field Name</th>
                                    <th>User</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {editHistory?.map((item: IAuditLogDisplayModel, i: number) => {
                                    return (
                                        <tr key={i}>
                                            <td>{item.displayName ?? item.fieldName}</td>
                                            <td>{item.user}</td>
                                            <td>{Common.dateTimeFormatToLocal(item.date)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className="pb-3">
                    <h5 className="pb-2" style={{ fontWeight: 500 }}>
                        Decision History
                    </h5>
                    {(decisionHistory?.length ?? 0) > 0 && (
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Previous</th>
                                    <th>Current</th>
                                    <th>User</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {decisionHistory?.map((item: IAuditLogModel, i: number) => (
                                    <tr key={i}>
                                        <td>{item.previousValue ?? '<Blank>'} </td>
                                        <td>{item.value ?? '<Blank>'} </td>
                                        <td>{item.user}</td>
                                        <td>{Common.dateTimeFormatToLocal(item.date)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className="pb-3">
                    <h5 className="pb-2" style={{ fontWeight: 500 }}>
                        Action Target History
                    </h5>
                    {props.actionTargetHistory && props.actionTargetHistory.length > 0 && (
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>User</th>
                                    <th>Date Targeted</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.actionTargetHistory &&
                                    props.actionTargetHistory?.map(
                                        (item: IKeyValuePairModel, i: number) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{item.key} </td>
                                                    <td>
                                                        {Common.dateTimeFormatToLocal(item.value)}
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )}
                            </tbody>
                        </table>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-black" onClick={props.onClose}>
                    OK
                </button>
            </Modal.Footer>
        </Modal>
    );
}
